













import Vue from "vue";

export default Vue.extend({
  name: "cwx-label",

  props: {
    absolute: {
      type: Boolean,
      default: false
    },
    //Determines whether the label has a class '.cwx-text-field .cwx-label--changed-display'
    changedDisplay: {
      type: Boolean,
      default: false
    },
    //Determines whether the label has a class 'cwx-label--is-disabled'
    disabled: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    focusedColor: {
      type: String,
      default: "#3561A0"
    },
    for: String,
    left: {
      type: [Number, String],
      default: 0
    },
    right: {
      type: [Number, String],
      default: "auto"
    }
  }
});
